import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './header.module.css';

interface Props {
  title: string;
  navigateBack: () => void;
}

const NavigationTitle = ({ title, navigateBack }: Props) => (
  <div>
    <IconButton tooltip="Back" onClick={navigateBack}>
      <Icon color={colors.neutral.white}>arrow_back</Icon>
    </IconButton>
    <div className={classes.titleBar}>
      <span>{title}</span>
    </div>
  </div>
);

export default NavigationTitle;
